import { importProvidersFrom } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { usersReducer } from './store/users.reducer';
import { featureName } from './store/users.state';

/**
 * This needs to be provided at the root of the app (or in every route or component that uses the users services)
 * This is sadly necessary to setup the store
 */
export function provideUsersDomain() {
    return importProvidersFrom(StoreModule.forFeature(featureName, usersReducer));
}
